import {Td, Th, Tr} from "@chakra-ui/react";
import React from "react";

import {CandidateStatus} from "../model/Constants";
import {CandidateSummaryDto} from "../model/Dto";
import {displayCandidateStatus, displayTime, getLicenseId, getLicenseName} from "../Utils";
import DownloadLicenseCertificate from "./DownloadLicenseCertificate";

type LicenseItemProps = {
  license: CandidateSummaryDto;
  userInstitution: string;
  isPublic?: boolean;
  isAdmin?: boolean;
};

const LicenseItem = (props: LicenseItemProps) => {

  const institution = props.license.institution !== null ? props.license.institution : "";
  const region = props.license.region !== null ? props.license.region : "";
  const institutionDisplay = institution && region ? institution+" - "+region : institution+region

  const endR: string = ((props.license.candidateR.status === CandidateStatus.TEST_COMPLETE) ?
    props.license.candidateR.endTime : "");
  const endL: string = ((props.license.candidateL.status === CandidateStatus.TEST_COMPLETE) ?
    props.license.candidateL.endTime : "");
  const endS: string = ((props.license.candidateS.status === CandidateStatus.TEST_COMPLETE) ?
    props.license.candidateS.endTime : "");

  const userId = getLicenseId(props.license);
  const name = getLicenseName(props.license);
  return (
    <Tr key={props.license.username}>
      <Td>{props.license.username}</Td>
      <Td>{userId}</Td>
      <Td>{name}</Td>
      <Td>{institutionDisplay}</Td>
      <Td>{props.license.userGroup}</Td>
      { !props.isPublic && <Td>
        <DownloadLicenseCertificate username={props.license.username} name={name}/>
      </Td> }
      <Td>{displayCandidateStatus(props.license.candidateR.status)}</Td>
      <Td>{displayTime(props.license.candidateR.startTime)}</Td>
      <Td>{displayTime(endR)}</Td>
      <Td>{props.license.candidateR.lastAnsweredQuestion}</Td>
      { !props.isPublic && <Td>{props.license.candidateR.level}</Td> }
      { !props.isPublic && props.userInstitution==="tweetalig" && <Td>{props.license.candidateR.score}</Td> }
      <Td>{displayCandidateStatus(props.license.candidateL.status)}</Td>
      <Td>{displayTime(props.license.candidateL.startTime)}</Td>
      <Td>{displayTime(endL)}</Td>
      <Td>{props.license.candidateL.lastAnsweredQuestion}</Td>
      { !props.isPublic && <Td>{props.license.candidateL.level}</Td> }
      { !props.isPublic && props.userInstitution==="tweetalig" && <Td>{props.license.candidateL.score}</Td> }
      <Td>{displayCandidateStatus(props.license.candidateS.status)}</Td>
      <Td>{displayTime(props.license.candidateS.startTime)}</Td>
      <Td>{displayTime(endS)}</Td>
      { !props.isPublic && <Td>{props.license.candidateS.level}</Td> }
      { props.isAdmin && <Td>{props.license.candidateS.reportUrl}</Td>}
      { !props.isPublic && props.userInstitution==="tweetalig" && <Td>{props.license.candidateS.score}</Td> }
      { !props.isPublic && <Td>{props.license.totalScore}</Td> }
    </Tr>
  );
};

export default LicenseItem;
